import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthService } from './modules/authentication/auth.service';
import { GeneralLoadingComponent } from './@core/shared/components/general-loading/general-loading.component';
import { LoadingService } from './@core/services/commonServices/loading.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule, GeneralLoadingComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'Tamiin_frontend'; // Set the title of the app

  constructor(
    public auth: AuthService,
    private readonly router: Router,
    private readonly loadingService: LoadingService,
  ) {
    // Save the current route on every successful navigation
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        localStorage.setItem('lastVisitedUrl', event.urlAfterRedirects);
      }
    });
  }

  ngOnInit() {
    // Show the loading screen immediately upon initialization
    this.showLoading();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.hideLoading();
      }
    });
  }

  // Show the loading screen
  showLoading() {
    this.loadingService.show();
  }

  // Hide the loading screen
  hideLoading() {
    this.loadingService.hide();
  }
}
